
import React from "react";
import { Subscription } from "@/types/subscription";
import { SubscriptionFormContainer } from "./subscription/SubscriptionFormContainer";

interface SubscriptionFormProps {
  onSubmit: (data: Omit<Subscription, "id" | "totalPaid">) => Promise<Subscription>;
  isLoading: boolean;
}

export default function SubscriptionForm({ onSubmit, isLoading }: SubscriptionFormProps) {
  return (
    <SubscriptionFormContainer 
      onSubmit={onSubmit}
      isLoading={isLoading}
    />
  );
}
